import { render, staticRenderFns } from "./OrderCustomer.vue?vue&type=template&id=c8b22f1e"
import script from "./OrderCustomer.vue?vue&type=script&lang=ts"
export * from "./OrderCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports